import {ofType} from 'redux-observable';
import {Observable, of} from 'rxjs';
import {filter} from 'rxjs/operators';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import * as GlobalEventActions from 'web-app/react/global-event/actions';
import * as PromptPasswordHelpers from 'web-app/react/modals-container/prompt-password-modal/helpers';

import * as Api from './api';
import * as Actions from './actions';

const fetchHealthObservable = (childId, password) =>
    Api.fetchHealth(childId, password)
        .map(({health, updateToken}) => Actions.fetchSuccess.action(health, updateToken))
        .catch(e => {
            if (e && e.errorCode === 1454496734) {
                return Observable.of(Actions.fetch.action(childId, true));
            } else {
                return Observable.of(Actions.fetchFailed.action(e));
            }
        });

const fetchWithPasswordPrompt = PromptPasswordHelpers.makePasswordModalEpic(
    action$ =>
        action$.pipe(
            ofType(Actions.fetch.type),
            filter(({payload}) => payload.needsPassword),
        ),
    (fetchAction, modalAction) => fetchHealthObservable(fetchAction.payload.childId, modalAction.payload.password),
    () => of(Actions.fetchAborted.action()),
);

const fetch = action$ =>
    action$
        .ofType(Actions.fetch.type)
        .filter(({payload}) => !payload.needsPassword)
        .mergeMap(({payload}) => fetchHealthObservable(payload.childId));

const update = action$ =>
    action$.ofType(Actions.update.type).mergeMap(({payload}) => {
        return Api.updateHealth(payload.childId, payload.health, payload.updateToken ? payload.updateToken.toJS() : {})
            .flatMap(() => [
                Actions.updateSuccess.action(payload.childId, payload.rawFormData),
                GlobalEventActions.updateSuccess.action(i18next.t('childProfile.profileUpdated')),
                // We want the history to update straight away. Therefore, we dispatch the fetch action to
                // refetch the health-information including the health history
                Actions.fetch.action(payload.childId),
            ])
            .catch(e => Observable.of(Actions.updateFailed.action(e)));
    });

export default combineEpics(fetch, update, fetchWithPasswordPrompt);
